var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGreenCheckedCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#00AB21"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8392 7.74408C19.1647 8.06951 19.1647 8.59715 18.8392 8.92259L10.5059 17.2559C10.1805 17.5814 9.65283 17.5814 9.32739 17.2559L5.57739 13.5059C5.25195 13.1805 5.25195 12.6528 5.57739 12.3274C5.90283 12.002 6.43047 12.002 6.7559 12.3274L9.91665 15.4882L17.6607 7.74408C17.9862 7.41864 18.5138 7.41864 18.8392 7.74408Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGreenCheckedCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/green_checked_circle.03604e5e4f41ab1b8854a444c4c5e189.svg";